export const limitFileName = (fileName: string, maxLength = 100): string => {
    if (fileName.length <= maxLength) return fileName;

    const extensionIndex = fileName.lastIndexOf('.');
    const extension = extensionIndex > 0 ? fileName.slice(extensionIndex) : '';

    if (extension.length >= maxLength) return fileName.slice(0, maxLength);

    const baseName = extension ? fileName.slice(0, extensionIndex) : fileName;
    return `${baseName.slice(0, maxLength - extension.length)}${extension}`;
};